[
  {
    "url": "http://localhost:8000/examples/coverage-input.html",
    "ranges": [
      {
        "start": 35,
        "end": 75
      },
      {
        "start": 106,
        "end": 129
      },
      {
        "start": 145,
        "end": 160
      }
    ],
    "text": "<html><h1 id=\"answer\"></h1><script>const x=1;const  y=2; const add=()=>x+y;function subtract(){return x-y};answer.innerText=add()</script><style>h1{color: red;}h2{color:blue;}</style></html>"
  }
]